// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__badMJ","list":"styles_list__3f5Ju"};